import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { AcmDashboardPromoDialogComponent } from './acm-dashboard-promo-dialog.component'

@Injectable({
  providedIn: 'root',
})
export class AcmDashboardPromoDialogService {
  constructor(private dialog: MatDialog) {}

  open() {
    const defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      data: {},
      panelClass: ['variable-modal'],
    }

    return this.dialog.open(AcmDashboardPromoDialogComponent, defaultConfig)
  }
}
